import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDesignFilters } from '../context';

export const FilterChips = () => {
  const { t } = useTranslation();
  const { filters, setFilter } = useDesignFilters();
  const tagItems = filters.tags.items;
  const publishedItems = filters.published.items;

  const toggleTagItem = (value: string) => {
    const newItems = tagItems.map((item) =>
      item.value === value ? { ...item, selected: !item.selected } : item,
    );
    setFilter({ field: 'tags', items: newItems });
  };

  const togglePublishedItem = (value: boolean) => {
    const newItems = publishedItems.map((item) =>
      item.value === value ? { ...item, selected: !item.selected } : item,
    );
    setFilter({ field: 'published', items: newItems });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {tagItems
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`tag-${f.value}`}
            label={`${t('common.labels.tags')}: ${f.label}`}
            color="primary"
            onDelete={() => toggleTagItem(f.value)}
          />
        ))}
      {publishedItems
        .filter((f) => f.selected)
        .map((f) => (
          <Chip
            key={`published-${f.value}`}
            label={`${t('pages.studio.filters.published')}: ${f.label}`}
            color="primary"
            onDelete={() => togglePublishedItem(f.value)}
          />
        ))}
    </Box>
  );
};
